import React from 'react';
import { SearchInputWrapper, SearchInputField, SearchIconWrapper } from './SearchInput.styled';
import { Icon } from "../../../../elements";

const SearchInput = ({
  value,
  onChange,
  placeholder = "Buscar...",
  height,
  iconHeight = "20px",
  iconWidth = "20px",
  iconName = "magnifier",
  className,
  style,
  ...restProps
}) => {
  return (
    <SearchInputWrapper className={className} style={style}>
      <SearchInputField
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        height={height}
        {...restProps}
      />
      <SearchIconWrapper>
        <Icon name={iconName} height={iconHeight} width={iconWidth} />
      </SearchIconWrapper>
    </SearchInputWrapper>
  );
};

export default SearchInput; 